import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "iconTextBlock__icon" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "iconTextBlock__icon" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "iconTextBlock__icon" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.to)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        class: _normalizeClass(["iconTextBlock", { 'iconTextBlock--inverted': _ctx.iconColor }]),
        to: _ctx.to
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.icon)
            }, null, 2)
          ]),
          _createElementVNode("div", {
            class: "iconTextBlock__label",
            innerHTML: _ctx.label
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }, 8, ["class", "to"]))
    : (_ctx.href)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          class: _normalizeClass(["iconTextBlock", { 'iconTextBlock--inverted': _ctx.iconColor }]),
          target: "_blank",
          href: _ctx.href
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.icon)
            }, null, 2)
          ]),
          _createElementVNode("div", {
            class: "iconTextBlock__label",
            innerHTML: _ctx.label
          }, null, 8, _hoisted_5)
        ], 10, _hoisted_3))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["iconTextBlock", { 'iconTextBlock--inverted': _ctx.iconColor }])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.icon)
            }, null, 2)
          ]),
          _createElementVNode("div", {
            class: "iconTextBlock__label",
            innerHTML: _ctx.label
          }, null, 8, _hoisted_7)
        ], 2))
}